import PropTypes from 'prop-types';
import styles from './NoContent.module.css';

const NoContentBox = ({ label = 'No content', ...props }) => {
  return (
    <div className={styles.no_content_box} {...props}>
      {label}
    </div>
  );
};

NoContentBox.propTypes = {
  label: PropTypes.string,
};

export default NoContentBox;
